import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import DestinationsSection from "../components/DestinationsSection";
import {
  TopToursSection,
  ThemesSection,
  SpiritualToursSection,
} from "../components/Sections";
import {
  BudgetSection,
  WhyUsSection,
  ContactForm,
  Footer,
  WhatsAppFloating,
} from "../components/Extras";
import { INTERNATIONAL, DOMESTIC, TOP_TOURS } from "../mock";
import { Toaster } from "../components/ui/sonner";

export default function Home() {
  return (
    <div className="min-h-screen bg-white text-slate-900 antialiased">
      <Header />
      <Hero />

      <DestinationsSection
        id="domestic"
        eyebrow="India"
        title="Explore India"
        subtitle="Unforgettable experiences across every state."
        items={DOMESTIC}
        bg="cream"
      />

      <DestinationsSection
        id="international"
        eyebrow="International"
        title="Explore Beyond Borders"
        subtitle="Handpicked South Asian getaways plus the glittering Dubai."
        items={INTERNATIONAL}
        bg="white"
      />

      <TopToursSection
        title="Top Tours of the Season"
        subtitle="Best-selling packages loved by thousands of Trevora travellers."
        ctaLabel="Check Out All Tours"
        tours={TOP_TOURS}
      />

      <ThemesSection />

      <SpiritualToursSection />

      <BudgetSection />

      <WhyUsSection />

      <ContactForm />

      <Footer />
      <WhatsAppFloating />
      <Toaster position="top-center" richColors />
    </div>
  );
}
